import { app } from '../../../../app';
import { Controller } from './edit-public-user-account.controller';

app.component('publicUserAccountsEdit', {
    bindings: {
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
        publicUserAccount: '<',
        publicUserAccounts: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-public-user-account.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/edit/edit-public-user-account.component.js